import { createContext, useContext, useEffect, useState } from "react";
import { content } from "@/i18n/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("amh-lang") || "ar");

  useEffect(() => {
    const root = document.documentElement;
    root.lang = lang;
    root.dir = content[lang].dir;
    root.style.fontFamily = lang === "ar" ? "'Tajawal', sans-serif" : "'Inter', 'Tajawal', sans-serif";
    localStorage.setItem("amh-lang", lang);
  }, [lang]);

  const toggleLang = () => setLang((l) => (l === "ar" ? "en" : "ar"));

  return (
    <LanguageContext.Provider value={{ lang, t: content[lang], toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
